import React from "react";
import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";
import "./style.scss";

// Первый показ информации о +57 (ТЗ п.7.5.1): сразу после смахивания 88-й карты
// ДО регистрации, один единственный раз; кнопка ПОНЯТНО, крестика нет.
export default function Extended57IntroModal() {
  const { t } = useTranslation();
  const { closeModal } = useModalActions();

  return (
    <BaseModal
      className="extended57-intro-modal"
      eventTypeModal={MODAL_TYPES.EXT57_INTRO}
      preventClose
      title={t("extended57.intro.title")}
      description={t("extended57.intro.text")}
    >
      <BaseButton onClick={() => closeModal(MODAL_TYPES.EXT57_INTRO)}>
        {t("extended57.intro.ok_btn")}
      </BaseButton>
    </BaseModal>
  );
}
